// Centroidi approssimativi dei paesi (lat, lng) usati nel CRM Pezzaioli.
const COUNTRY_COORDS = {
    'Italia':            { lat: 42.80,  lng: 12.60,  label: 'Italia' },
    'Spagna':            { lat: 40.20,  lng: -3.70,  label: 'Spagna' },
    'Portogallo':        { lat: 39.60,  lng: -8.00,  label: 'Portogallo' },
    'UK':                { lat: 53.00,  lng: -1.50,  label: 'Regno Unito' },
    'Irlanda':           { lat: 53.20,  lng: -7.90,  label: 'Irlanda' },
    'Islanda':           { lat: 64.90,  lng: -18.60, label: 'Islanda' },
    'Francia':           { lat: 46.60,  lng: 2.40,   label: 'Francia' },
    'Belgio':            { lat: 50.60,  lng: 4.60,   label: 'Belgio' },
    'Lussemburgo':       { lat: 49.75,  lng: 6.10,   label: 'Lussemburgo' },
    'Olanda':            { lat: 52.20,  lng: 5.40,   label: 'Olanda' },
    'Svizzera':          { lat: 46.80,  lng: 8.20,   label: 'Svizzera' },
    'Austria':           { lat: 47.55,  lng: 14.20,  label: 'Austria' },
    'Germania':          { lat: 51.10,  lng: 10.40,  label: 'Germania' },
    'Polonia':           { lat: 52.00,  lng: 19.30,  label: 'Polonia' },
    'Repubblica Ceca':   { lat: 49.80,  lng: 15.50,  label: 'Repubblica Ceca' },
    'Slovacchia':        { lat: 48.70,  lng: 19.60,  label: 'Slovacchia' },
    'Ungheria':          { lat: 47.10,  lng: 19.40,  label: 'Ungheria' },
    'Romania':           { lat: 45.90,  lng: 25.00,  label: 'Romania' },
    'Moldavia':          { lat: 47.20,  lng: 28.50,  label: 'Moldavia' },
    'Bulgaria':          { lat: 42.70,  lng: 25.40,  label: 'Bulgaria' },
    'Slovenia':          { lat: 46.10,  lng: 14.90,  label: 'Slovenia' },
    'Croazia':           { lat: 45.50,  lng: 16.20,  label: 'Croazia' },
    'Bosnia':            { lat: 44.10,  lng: 17.80,  label: 'Bosnia ed Erzegovina' },
    'Serbia':            { lat: 44.10,  lng: 20.90,  label: 'Serbia' },
    'Montenegro':        { lat: 42.70,  lng: 19.30,  label: 'Montenegro' },
    'Kosovo':            { lat: 42.60,  lng: 20.90,  label: 'Kosovo' },
    'Macedonia':         { lat: 41.60,  lng: 21.70,  label: 'Macedonia del Nord' },
    'Albania':           { lat: 41.10,  lng: 20.10,  label: 'Albania' },
    'Grecia':            { lat: 39.30,  lng: 22.00,  label: 'Grecia' },
    'Cipro':             { lat: 35.10,  lng: 33.30,  label: 'Cipro' },
    'Turchia':           { lat: 39.20,  lng: 34.50,  label: 'Turchia' },
    'Norvegia':          { lat: 61.50,  lng: 9.00,   label: 'Norvegia' },
    'Danimarca':         { lat: 56.00,  lng: 9.70,   label: 'Danimarca' },
    'Svezia':            { lat: 60.00,  lng: 15.50,  label: 'Svezia' },
    'Finlandia':         { lat: 62.50,  lng: 26.00,  label: 'Finlandia' },
    'Scandinavia':       { lat: 61.00,  lng: 14.00,  label: 'Scandinavia' },
    'Estonia':           { lat: 58.70,  lng: 25.50,  label: 'Estonia' },
    'Lettonia':          { lat: 56.90,  lng: 24.90,  label: 'Lettonia' },
    'Lituania':          { lat: 55.30,  lng: 23.90,  label: 'Lituania' },
    'Baltici':           { lat: 57.00,  lng: 25.00,  label: 'Paesi Baltici' },
    'Bielorussia':       { lat: 53.60,  lng: 28.00,  label: 'Bielorussia' },
    'Ucraina':           { lat: 49.00,  lng: 31.50,  label: 'Ucraina' },
    'Russia':            { lat: 56.00,  lng: 40.00,  label: 'Russia' },
    'CSI':               { lat: 55.00,  lng: 50.00,  label: 'CSI' },
    'Georgia':           { lat: 42.00,  lng: 43.50,  label: 'Georgia' },
    'Armenia':           { lat: 40.20,  lng: 44.90,  label: 'Armenia' },
    'Azerbaijan':        { lat: 40.40,  lng: 47.80,  label: 'Azerbaijan' },
    'Kazakistan':        { lat: 48.00,  lng: 67.00,  label: 'Kazakistan' },
    'Uzbekistan':        { lat: 41.50,  lng: 64.50,  label: 'Uzbekistan' },
    'Kyrgyzstan':        { lat: 41.50,  lng: 74.80,  label: 'Kirghizistan' },
    'Mongolia':          { lat: 46.90,  lng: 103.80, label: 'Mongolia' },
    'Israele':           { lat: 31.50,  lng: 34.90,  label: 'Israele' },
    'Arabia Saudita':    { lat: 24.00,  lng: 45.00,  label: 'Arabia Saudita' },
    'Emirati Arabi':     { lat: 24.00,  lng: 54.00,  label: 'Emirati Arabi Uniti' },
    'Marocco':           { lat: 32.00,  lng: -6.00,  label: 'Marocco' },
    'Algeria':           { lat: 28.00,  lng: 2.60,   label: 'Algeria' },
    'Tunisia':           { lat: 34.00,  lng: 9.50,   label: 'Tunisia' },
    'Libia':             { lat: 27.00,  lng: 17.20,  label: 'Libia' },
    'Egitto':            { lat: 26.80,  lng: 30.00,  label: 'Egitto' },
    'Guinea':            { lat: 10.90,  lng: -11.30, label: 'Guinea' },
    'Botswana':          { lat: -22.30, lng: 24.70,  label: 'Botswana' },
    'Sudafrica':         { lat: -29.00, lng: 25.00,  label: 'Sudafrica' },
    'USA':               { lat: 39.80,  lng: -98.50, label: 'USA' },
    'Canada':            { lat: 53.00,  lng: -100.0, label: 'Canada' },
    'Bahamas':           { lat: 25.00,  lng: -77.40, label: 'Bahamas' },
    'Isole Vergini Britanniche': { lat: 18.40, lng: -64.60, label: 'Isole Vergini Britanniche' },
    'Brasile':           { lat: -10.00, lng: -52.00, label: 'Brasile' },
    'Australia':         { lat: -25.30, lng: 133.80, label: 'Australia' },
    'Nuova Caledonia':   { lat: -21.30, lng: 165.50, label: 'Nuova Caledonia' },
};

// Alias (normalizzati) → chiave canonica della tabella
const ALIASES = {
    'italy': 'Italia',
    'spain': 'Spagna', 'espana': 'Spagna',
    'portugal': 'Portogallo',
    'uk': 'UK', 'gran bretagna': 'UK', 'regno unito': 'UK', 'inghilterra': 'UK', 'united kingdom': 'UK', 'england': 'UK', 'great britain': 'UK', 'scozia': 'UK', 'galles': 'UK', 'irlanda del nord': 'UK',
    'ireland': 'Irlanda', 'eire': 'Irlanda',
    'iceland': 'Islanda',
    'france': 'Francia',
    'belgium': 'Belgio', 'belgique': 'Belgio',
    'luxembourg': 'Lussemburgo', 'lussemburgo': 'Lussemburgo',
    'olanda (paesi bassi)': 'Olanda', 'paesi bassi': 'Olanda', 'netherlands': 'Olanda', 'holland': 'Olanda', 'nederland': 'Olanda',
    'switzerland': 'Svizzera', 'schweiz': 'Svizzera', 'suisse': 'Svizzera',
    'austria': 'Austria', 'osterreich': 'Austria',
    'germany': 'Germania', 'deutschland': 'Germania',
    'poland': 'Polonia', 'polska': 'Polonia',
    'ceca (repubblica)': 'Repubblica Ceca', 'rep. ceca': 'Repubblica Ceca', 'rep ceca': 'Repubblica Ceca', 'cechia': 'Repubblica Ceca', 'czech republic': 'Repubblica Ceca', 'czechia': 'Repubblica Ceca',
    'slovakia': 'Slovacchia', 'slovacca (repubblica)': 'Slovacchia',
    'hungary': 'Ungheria',
    'romania': 'Romania',
    'moldova': 'Moldavia', 'moldavia': 'Moldavia',
    'bulgaria': 'Bulgaria',
    'slovenia': 'Slovenia',
    'croatia': 'Croazia', 'hrvatska': 'Croazia',
    'bosnia e erzegovina': 'Bosnia', 'bosnia ed erzegovina': 'Bosnia', 'bosnia-erzegovina': 'Bosnia', 'bosnia and herzegovina': 'Bosnia',
    'serbia': 'Serbia', 'srbija': 'Serbia',
    'montenegro': 'Montenegro',
    'kosovo': 'Kosovo',
    'macedonia': 'Macedonia', 'macedonia del nord': 'Macedonia', 'north macedonia': 'Macedonia',
    'albania': 'Albania',
    'greece': 'Grecia',
    'cyprus': 'Cipro',
    'turkey': 'Turchia', 'turkiye': 'Turchia',
    'norway': 'Norvegia',
    'denmark': 'Danimarca',
    'sweden': 'Svezia',
    'finland': 'Finlandia',
    'estonia': 'Estonia', 'latvia': 'Lettonia', 'lithuania': 'Lituania',
    'paesi baltici': 'Baltici',
    'belarus': 'Bielorussia',
    'ukraine': 'Ucraina',
    'russia': 'Russia', 'federazione russa': 'Russia', 'russian federation': 'Russia',
    'georgia': 'Georgia', 'armenia': 'Armenia', 'azerbaijan': 'Azerbaijan', 'azerbaigian': 'Azerbaijan',
    'kazakhstan': 'Kazakistan', 'kazakistan': 'Kazakistan',
    'uzbekistan': 'Uzbekistan',
    'kyrgyzstan': 'Kyrgyzstan', 'kirghizistan': 'Kyrgyzstan',
    'mongolia': 'Mongolia',
    'israel': 'Israele',
    'arabia saudita': 'Arabia Saudita', 'saudi arabia': 'Arabia Saudita',
    'emirati arabi uniti': 'Emirati Arabi', 'uae': 'Emirati Arabi', 'united arab emirates': 'Emirati Arabi',
    'morocco': 'Marocco', 'algeria': 'Algeria', 'tunisia': 'Tunisia', 'libya': 'Libia', 'egypt': 'Egitto', 'egitto': 'Egitto',
    'guinea': 'Guinea', 'botswana': 'Botswana',
    'sudafricana (repubblica)': 'Sudafrica', 'sud africa': 'Sudafrica', 'south africa': 'Sudafrica',
    'u.s.a.': 'USA', 'usa': 'USA', 'stati uniti': 'USA', 'united states': 'USA', 'us': 'USA',
    'canada': 'Canada',
    'bahamas': 'Bahamas',
    'isole vergini britanniche': 'Isole Vergini Britanniche',
    'brasile': 'Brasile', 'brazil': 'Brasile',
    'australia': 'Australia',
    'nuova caledonia': 'Nuova Caledonia', 'new caledonia': 'Nuova Caledonia',
};

const normalize = (s) => (s || '')
    .toString()
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

const CANONICAL_BY_NORM = Object.fromEntries(Object.keys(COUNTRY_COORDS).map(k => [normalize(k), k]));

// Ritorna la chiave canonica del paese oppure null se sconosciuto
export const resolveCountry = (name) => {
    const n = normalize(name);
    if (!n) return null;
    return CANONICAL_BY_NORM[n] || ALIASES[n] || null;
};

// Ritorna {lat,lng,label} oppure null se il paese non è geolocalizzabile
export const getCountryCoord = (name) => {
    const key = resolveCountry(name);
    return key ? COUNTRY_COORDS[key] : null;
};

export default COUNTRY_COORDS;
